/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetUserSessionIssuerRequestBody,
  SetUserSessionIssuerRequestBody$Outbound,
  SetUserSessionIssuerRequestBody$outboundSchema,
} from "../components/setusersessionissuerrequestbody.js";

export type SetToolsetUserSessionIssuerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SetToolsetUserSessionIssuerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SetToolsetUserSessionIssuerSecurity = {
  option1?: SetToolsetUserSessionIssuerSecurityOption1 | undefined;
  option2?: SetToolsetUserSessionIssuerSecurityOption2 | undefined;
};

export type SetToolsetUserSessionIssuerRequest = {
  /**
   * The slug of the toolset to link
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setUserSessionIssuerRequestBody: SetUserSessionIssuerRequestBody;
};

/** @internal */
export type SetToolsetUserSessionIssuerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SetToolsetUserSessionIssuerSecurityOption1$outboundSchema:
  z.ZodMiniType<
    SetToolsetUserSessionIssuerSecurityOption1$Outbound,
    SetToolsetUserSessionIssuerSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setToolsetUserSessionIssuerSecurityOption1ToJSON(
  setToolsetUserSessionIssuerSecurityOption1:
    SetToolsetUserSessionIssuerSecurityOption1,
): string {
  return JSON.stringify(
    SetToolsetUserSessionIssuerSecurityOption1$outboundSchema.parse(
      setToolsetUserSessionIssuerSecurityOption1,
    ),
  );
}

/** @internal */
export type SetToolsetUserSessionIssuerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SetToolsetUserSessionIssuerSecurityOption2$outboundSchema:
  z.ZodMiniType<
    SetToolsetUserSessionIssuerSecurityOption2$Outbound,
    SetToolsetUserSessionIssuerSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function setToolsetUserSessionIssuerSecurityOption2ToJSON(
  setToolsetUserSessionIssuerSecurityOption2:
    SetToolsetUserSessionIssuerSecurityOption2,
): string {
  return JSON.stringify(
    SetToolsetUserSessionIssuerSecurityOption2$outboundSchema.parse(
      setToolsetUserSessionIssuerSecurityOption2,
    ),
  );
}

/** @internal */
export type SetToolsetUserSessionIssuerSecurity$Outbound = {
  Option1?: SetToolsetUserSessionIssuerSecurityOption1$Outbound | undefined;
  Option2?: SetToolsetUserSessionIssuerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SetToolsetUserSessionIssuerSecurity$outboundSchema: z.ZodMiniType<
  SetToolsetUserSessionIssuerSecurity$Outbound,
  SetToolsetUserSessionIssuerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => SetToolsetUserSessionIssuerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => SetToolsetUserSessionIssuerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function setToolsetUserSessionIssuerSecurityToJSON(
  setToolsetUserSessionIssuerSecurity: SetToolsetUserSessionIssuerSecurity,
): string {
  return JSON.stringify(
    SetToolsetUserSessionIssuerSecurity$outboundSchema.parse(
      setToolsetUserSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type SetToolsetUserSessionIssuerRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetUserSessionIssuerRequestBody: SetUserSessionIssuerRequestBody$Outbound;
};

/** @internal */
export const SetToolsetUserSessionIssuerRequest$outboundSchema: z.ZodMiniType<
  SetToolsetUserSessionIssuerRequest$Outbound,
  SetToolsetUserSessionIssuerRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setUserSessionIssuerRequestBody:
      SetUserSessionIssuerRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      setUserSessionIssuerRequestBody: "SetUserSessionIssuerRequestBody",
    });
  }),
);

export function setToolsetUserSessionIssuerRequestToJSON(
  setToolsetUserSessionIssuerRequest: SetToolsetUserSessionIssuerRequest,
): string {
  return JSON.stringify(
    SetToolsetUserSessionIssuerRequest$outboundSchema.parse(
      setToolsetUserSessionIssuerRequest,
    ),
  );
}
